<script setup>
import { defineProps, onMounted, ref, watch, defineEmits } from 'vue'

const props = defineProps({
    conferenceFilters: Array,
    isSingle: Boolean
})
const emits = defineEmits(['detectSelect'])

const conferenceFiltersRef = ref(props.conferenceFilters)
const selectedFilters = ref([])

const toggleShowingFilters = (index) => {
    conferenceFiltersRef.value[index].isShow = !conferenceFiltersRef.value[index].isShow

    if (conferenceFiltersRef.value[index].isShow) {
        document.getElementById(`dropdown-arrow-${index}`).style.transform = 'rotate(0)'
    } else {
        document.getElementById(`dropdown-arrow-${index}`).style.transform = 'rotate(180deg)'
    }
}

watch(selectedFilters, () => {
    const formattedSelectedFilters = []

    for (const id of selectedFilters.value) {
        if (!Array.isArray(id)) formattedSelectedFilters.push(id)
        else formattedSelectedFilters.push(...id)
    }

    emits('detectSelect', formattedSelectedFilters)
})

onMounted(() => {
    conferenceFiltersRef.value.map(filter => filter.isShow = true)
})
</script>

<template>
    <div v-if="!props.isSingle">
        <div
            v-for="(filter, index) in conferenceFiltersRef"
            :key="filter.id"
            class="main-filter"
        >
            <h3 @click="toggleShowingFilters(index)">
                {{ filter.title }}
                <span>
                    <img
                        :id="`dropdown-arrow-${index}`"
                        src="/svg/dropdown_arrow.svg"
                        alt="arrow"
                    >
                </span>
            </h3>
            <div v-if="filter.isShow" class="filter-checkboxes">
                <v-checkbox
                    v-for="subFilter in filter.filters"
                    :key="subFilter.id"
                    v-model="selectedFilters"
                    :value="subFilter.tagsId === undefined ? subFilter.id : subFilter.tagsId"
                    :label="subFilter.title"
                    color="#0635AC"
                    hide-details
                />
            </div>
        </div>
    </div>
    <div v-else>
        <v-checkbox
            v-for="filter in props.conferenceFilters"
            :key="filter.id"
            v-model="selectedFilters"
            :value="filter.tagsId === undefined ? filter.id : filter.tagsId"
            :label="filter.title"
            color="#0635AC"
            hide-details
        />
    </div>
</template>

<style lang="scss" scoped>
.main-filter {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 15px;
    text-align: left;

    h3 {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        color: #0635ac;
        cursor: pointer;

        &:hover {
            color: #2453ca;
            transition: color .2s;
        }
    }

    .filter-checkboxes {
        display: flex;
        flex-direction: column;
    }
}

:deep(.v-label) {
    text-align: left;
}
</style>